import { render, staticRenderFns } from "./AppButtonHeader.vue?vue&type=template&id=27b6b500&"
import script from "./AppButtonHeader.vue?vue&type=script&lang=js&"
export * from "./AppButtonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports